import { render, staticRenderFns } from "./FourOFour.vue?vue&type=template&id=2ec5735f&"
import script from "./FourOFour.vue?vue&type=script&lang=js&"
export * from "./FourOFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports